import React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Button content (label, icon, or both) */
  children: React.ReactNode;
  /** Optional CSS class name for styling */
  className?: string;
  /** Click handler */
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  /** Button type. Default: "button" to avoid accidental form submit */
  type?: 'button' | 'submit' | 'reset';
  /** Disabled state */
  disabled?: boolean;
}

/**
 * Generic button component. Use for consistent button behavior and to pass
 * className/aria-label/onClick from CSS modules or parent components.
 */
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, onClick, type = 'button', disabled = false, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={className}
        onClick={onClick}
        disabled={disabled}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';

export default Button;
